var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');

function init() {
	function onViewportState() {
		var state = ViewportTracker.getState();
		if (state == 'desktop') {
			$('#searchDropdownTrigger').on('click', function () {
				var expanded = $(this).attr('aria-expanded');
				$(this).attr('aria-expanded', expanded === 'true' ? 'false' : 'true');
				if (expanded === 'false') {
					$('.headerSearchForm__query').trigger('focus');
				}
			});

			$(document).on('keydown', function (event) {
				if (event.key === 'Escape') {
					var expanded = $('#searchDropdownTrigger').attr('aria-expanded');
					if (expanded === 'true') {
						$('#searchDropdownTrigger').attr('aria-expanded', 'false');
					}
				}
			});

			$(document).on('click', function (event) {
				if (!$(event.target).closest('.headerSearchForm__inner').length && !$(event.target).closest('#searchDropdownTrigger').length) {
					var expanded = $('#searchDropdownTrigger').attr('aria-expanded');
					if (expanded === 'true') {
						$('#searchDropdownTrigger').attr('aria-expanded', 'false');
					}
				}
			});
		}
	}
	onViewportState();
}

module.exports = {
	init : init
};
